<template>
  <b-form-textarea
    :class="classes"
    :disabled="disabled"
    :value="value"
    v-bind="$attrs"
    @input="$emit('input', $event)"
  />
</template>

<script>

export default {
    name: 'VtTextarea',
    props: {
        disabled: { type: Boolean, default: false },
        value: {
            validator: (prop) => { return typeof prop === 'string' || prop === null }
        }
    },
    computed: {
        classes() {
            return {
                'vt-textarea': true,
                'filled': this.value
            }
        }
    }
}

</script>

<style scoped lang="scss">

.vt-textarea {
  opacity: .5;
  border-color: vt-color(grey);
  color: vt-color(grey);
  &:focus {
    opacity: 1;
    border-color: vt-color(primary);
    box-shadow: none;
  }
  &:disabled {
    opacity: .5;
    background-color: rgba(196, 196, 196, 0.3);
  }
}

.vt-textarea.filled:not(:disabled) {
  opacity: 1;
}

</style>
